module.exports = __webpack_public_path__ + "officialStatic/fonts/PingFangSCBold.444cc4a.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/woff2/PingFangSCBold.woff2
// module id = IcgD
// module chunks = 0